import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../../hooks/useAdmin';
import { useAuth } from '../../hooks/useAuth';
import { BurgerMenu } from './BurgerMenu';
import './LandingNavbar.css';

const LandingNavbar = () => {
  const navigate = useNavigate();
  const { isCustomer } = useAdmin();
  const { user } = useAuth();
  return (
    <nav className="landing-navbar">
      <div className="landing-logo">
        <img
          src="/static/ManageConnect-Logo.svg"
          alt="ManageConnect Logo"
          className="navbar-logo-img"
          onClick={() => navigate(isCustomer ? '/customer' : '/')}
          style={{ cursor: 'pointer' }}
        />
        <div className="navbar-logo-text-container">
          <span className="navbar-logo-text navbar-logo-text-manage">Manage</span>
          <span className="navbar-logo-text navbar-logo-text-connect">Connect</span>
          <span className="navbar-logo-emoji">🧪</span>
        </div>
      </div>
      <div className="landing-navbar-right">
        {user?.displayName && <span className="landing-navbar-username">{user.displayName}</span>}
        <BurgerMenu currentPage="landing" />
      </div>
    </nav>
  );
};

export default LandingNavbar;
